<div [ngClass]="modalData?.modalClass">
  <div class="a-modal-title"
       *ngIf="modalData?.showIcon">
    <i class="icon fi"
       [ngClass]="modalData?.iconClassName"
    ></i>
  </div>
  <div class="a-modal-text"
       [innerHTML]="modalData?.headerText"
       vTp="header">
  </div>
  <div class="a-modal-button">
    <button class="a-button-ok"
         (click)="submitFunc($event)" [disabled]="isSubmitBtnDisabled()"
         [innerHtml]="modalData?.submitBtnText | translate">
    </button>
    <button class="a-button-cancel"
         *ngIf="modalData?.hidePopupBtn"
         (click)="hideFunc($event)"
         [innerHtml]="modalData?.hidePopupBtnText | translate">
    </button>
  </div>
</div>
